module.exports = __webpack_public_path__ + "img/multitank_banner.1b373ad1.jpg";